const state = {
  accountApiKey: { api_key: null },
  authorizedApps: null,
  currentAccount: null,
  currentAccountNav: null,
  defaultAccount: {},
  featureFlags: {},
  orgPodcasts: [],
  orgPodcastsCount: 0,
  orgPodcastsTotal: 0,
  privateApps: null,
  twoFactor: null,
  updateError: null,
  user: {},
  userInvites: []
}

export default state
